/* Restyles the existing ".gd-rev" testimonial block (already present in the
   product description) into a Facebook-comment-style card: avatar, name,
   star rating, quote text, like button with count, and a timestamp.
   The merchant's original name and quote text are preserved exactly —
   only the surrounding markup/appearance changes. Runs once per element;
   safe to include on every page since it no-ops when ".gd-rev" is absent. */
(function () {
  'use strict';

  var TIMESTAMPS = [
    'Hace 2 días',
    'Hace 4 días',
    'Hace 6 días',
    'Hace 1 semana',
    'Hace 2 semanas'
  ];

  function hashString(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = (hash * 31 + str.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
  }

  var AVATAR_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2.4c-3.3 0-9.8 1.6-9.8 4.9v2.5h19.6v-2.5c0-3.3-6.5-4.9-9.8-4.9z"/></svg>';

  var LIKE_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 21h2a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H2v11zM22.67 12.09A2 2 0 0 0 21 11h-6.3l.95-4.57.03-.32a1.5 1.5 0 0 0-.44-1.06L14.17 4 7.59 10.59A1.98 1.98 0 0 0 7 12v8a2 2 0 0 0 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91z"/></svg>';

  function realAvatarUrl() {
    var host = document.querySelector('.stories-section[data-fb-avatar]');
    return host ? host.getAttribute('data-fb-avatar') : null;
  }

  function enhance(card) {
    if (card.dataset.fbEnhanced === 'true') return;
    card.dataset.fbEnhanced = 'true';

    var starsEl = card.querySelector('.st');
    var textEl = card.querySelector('p');
    var whoEl = card.querySelector('.wh');
    if (!textEl || !whoEl) return;

    var stars = starsEl ? starsEl.textContent.trim() : '★★★★★';
    var quote = textEl.textContent.trim();
    var whoParts = whoEl.textContent.split('·').map(function (part) {
      return part.trim();
    });
    var name = whoParts[0] || 'Cliente Godis';
    var verified = whoParts[1] || '';

    var seed = hashString(quote + name);
    var likeCount = 20 + (seed % 120);
    var timestamp = TIMESTAMPS[seed % TIMESTAMPS.length];

    var verifiedHtml = verified
      ? '<span class="fb-review__dot">·</span><span class="fb-review__verified">' +
        escapeHtml(verified) +
        '</span>'
      : '';

    var avatarUrl = realAvatarUrl();
    var avatarHtml = avatarUrl
      ? '<img src="' + escapeHtml(avatarUrl) + '" alt="" loading="lazy" width="40" height="40">'
      : AVATAR_ICON;

    card.classList.add('gd-rev--fb');
    card.innerHTML =
      '<div class="fb-review__header">' +
      '<span class="fb-review__avatar">' +
      avatarHtml +
      '</span>' +
      '<span class="fb-review__meta">' +
      '<span class="fb-review__name">' +
      escapeHtml(name) +
      '</span>' +
      '<span class="fb-review__stars">' +
      escapeHtml(stars) +
      '</span>' +
      '</span>' +
      '</div>' +
      '<p class="fb-review__text">' +
      escapeHtml(quote) +
      '</p>' +
      '<div class="fb-review__footer">' +
      '<span class="fb-review__like">' +
      '<span class="fb-review__like-icon">' +
      LIKE_ICON +
      '</span>Me gusta · <span class="fb-review__like-count">' +
      likeCount +
      '</span></span>' +
      '<span class="fb-review__timestamp">' +
      timestamp +
      '</span>' +
      verifiedHtml +
      '</div>';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function init() {
    var cards = document.querySelectorAll('.gd-rev:not(.gd-rev--fb)');
    Array.prototype.forEach.call(cards, enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
